import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  emits: ['click:remove'],
  setup(__props) {



const isHovered = ref(false)

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", {
    "data-id": "file-upload-icon-wrapper",
    onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (isHovered.value = true)),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (isHovered.value = false))
  }, [
    _withDirectives(_createVNode(_component_q_icon, {
      "data-id": "file-upload-icon__error",
      name: "mdi-alert-circle-outline",
      color: "red",
      size: "18px",
      title: _ctx.$t('upload.upload_failed')
    }, null, 8, ["title"]), [
      [_vShow, !isHovered.value]
    ]),
    _withDirectives(_createVNode(_component_q_icon, {
      "data-id": "file-upload-icon__close-btn",
      name: "mdi-close",
      class: "cursor-pointer",
      size: "18px",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click:remove')))
    }, null, 512), [
      [_vShow, isHovered.value]
    ])
  ], 32))
}
}

})